import * as React from "react"

import { SelectContent as BaseSelectContent } from "@easyflow/ui-frontend/components/ui/select"

export {
  Select,
  SelectGroup,
  SelectValue,
  SelectTrigger,
  SelectLabel,
  SelectItem,
  SelectSeparator,
  SelectScrollUpButton,
  SelectScrollDownButton,
} from "@easyflow/ui-frontend/components/ui/select"

type SelectContentProps = React.ComponentPropsWithoutRef<typeof BaseSelectContent>

const SelectContent = React.forwardRef<
  React.ElementRef<typeof BaseSelectContent>,
  SelectContentProps
>(({ position = "item-aligned", ...props }, ref) => (
  <BaseSelectContent ref={ref} position={position} {...props} />
))
SelectContent.displayName = "VoipSelectContent"

export { SelectContent }
